import { defineStore } from "pinia";
import { ref } from "vue";
import api from "@/utils/axios";
import { useRouter } from "vue-router";
import { useAuthStore } from "./useAuthStore";

export const useMenuStore = defineStore("menuStore", () => {
  const menus = ref([]);
  const loading = ref(false);
  const error = ref(null);

  const fetchMenus = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.warn("🚫 Tidak ada token, menu tidak diambil.");
      const authStore = useAuthStore();
      await authStore.logout(); // aman logout
      return;
    }

    loading.value = true;
    error.value = null;

    try {
      const response = await api.get("/menus/sidebar");
      menus.value = response.data.data;
      console.log("✅ Menu berhasil diambil:", menus.value);
    } catch (err) {
      console.error("❌ Error fetching menus:", err);
      error.value = "Gagal mengambil menu.";
    } finally {
      loading.value = false;
    }
  };

  return {
    menus,
    loading,
    error,
    fetchMenus,
  };
});
